import { getBooleanRouteAttribute } from '@/root/shared-helpers/route-attributes/getBooleanRouteAttribute'
import type { SailPackage } from '@/root/shared-types/reservation/reservation-types'

export const HIDE_PASSENGER_DATA_FORM = 'HIDE_PASSENGER_DATA_FORM' as const

/** Whether the passenger data form is hidden for this sail package. false/absent → shown. */
export const isPassengerDataFormHidden = (sailPackage?: Pick<SailPackage, 'routeAttributes'>): boolean =>
  getBooleanRouteAttribute({ routeAttributes: sailPackage?.routeAttributes, key: HIDE_PASSENGER_DATA_FORM }) === true

interface PassengerFormVisibilityParams {
  priceCategoryType?: string
  isResident: boolean
  hidePassengerDataForm: boolean
}

/** Card render decision: whether to show the form and the id-only mode (resident when the form is hidden). */
export const getPassengerFormVisibility = ({
  priceCategoryType,
  isResident,
  hidePassengerDataForm,
}: PassengerFormVisibilityParams): { showForm: boolean; personalIdOnly: boolean } => {
  if (priceCategoryType === 'CAR_DECK') return { showForm: false, personalIdOnly: false }
  if (!hidePassengerDataForm) return { showForm: true, personalIdOnly: false }
  return { showForm: isResident, personalIdOnly: isResident }
}
